import { AlertService } from '@/services/alert.service';
import { NgTemplateOutlet } from '@angular/common';
import { Component, Inject, LOCALE_ID, OnDestroy } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { PropertySale, SalesManagementService } from '@eemo/api-client';
import { Subscription } from 'rxjs';
import { CompanyDialogComponent } from '../company-dialog/company-dialog.component';

import { ModalBaseComponent } from '../base/modal-base/modal-base.component';
import { InputComponent } from '../ui-forms/input/input.component';
import { SelectComponent } from '../ui-forms/select/select.component';

export class SaleEPubDialogData {
  sale: PropertySale;
}

@Component({
  selector: 'app-sale-epub-dialog',
  templateUrl: './sale-epub-dialog.component.html',
  styleUrls: ['./sale-epub-dialog.component.scss'],
  standalone: true,
  imports: [
    ModalBaseComponent,
    NgTemplateOutlet,
    MatDialogModule,
    FormsModule,
    ReactiveFormsModule,
    SelectComponent,
    InputComponent
  ]
})
export class SaleEPubDialogComponent implements OnDestroy {
  sub = new Subscription();
  dialogTitle: string;
  isLoading = false;

  message = "Une publication prête à l'emploi va vous être envoyée par email.";

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: SaleEPubDialogData,
    private fb: UntypedFormBuilder,
    public dialogRef: MatDialogRef<CompanyDialogComponent>,
    private salesService: SalesManagementService,
    private alertService: AlertService,
    @Inject(LOCALE_ID) public locale: string
  ) {
    this.dialogTitle = 'saleEPubDialog.title';
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  onSubmit(): void {
    this.isLoading = true;
    this.sub = this.salesService.sendSaleEpub(this.data.sale.uid).subscribe({
      next: () => {
        this.alertService.success('Publication envoyée avec succès');
        this.dialogRef.close(true);
      },
      error: () => {
        this.isLoading = false;
      }
    });
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }
}
